import { Component, Children } from 'react';
import styled, { css } from 'styled-components';
import { size } from '../../../../../common/css/setting/variable';

import ErrorBoundaryWrapper from '../../../../../common/handler/ErrorBoundaryWrapper';

interface Props {
  readonly hasOverlayAd?: boolean;
  readonly children?: React.ReactNode;
}

interface State {
  canStickToBottom: boolean;
}

const Wrapper = styled.div<{
  $canStickToBottom: boolean;
}>`
  width: ${size.width_sideColumn_pc};
  padding-top: 12px;
  margin-left: ${size.margin_left_sideColumn_pc};
  display: flex;
  flex-direction: column;
  justify-content: start;
  ${props =>
    props.$canStickToBottom &&
    css`
      justify-content: end;
    `}
`;

const FixableArea = styled.div<{ $hasPadding: boolean; $canStickToBottom: boolean }>`
  position: sticky;
  bottom: 0;
  width: ${size.width_sideColumn_pc};
  ${props =>
    props.$hasPadding &&
    css`
      bottom: 100px;
    `}
`;

export default class SubFrame extends Component<Props, State> {
  private resizeObserver: ResizeObserver | null = null;

  constructor(props: Props) {
    super(props);
    this.state = {
      canStickToBottom: false
    };
  }
  /**
   *
   */
  public componentDidMount() {
    if (process.env.NODE_ENV !== 'test') {
      setInterval(this.changeViewportWhenPrimeVisionShown, 300);
    }
    this.registerFixedValidation();
    this.subColumnFixed();
  }

  /**
   *
   */
  public componentWillUnmount() {
    this.unregisterFixedValidation();
  }

  /**
   *
   */
  public render() {
    const wrapped = Children.map(this.props.children, child => <ErrorBoundaryWrapper component={child} />);
    return (
      <Wrapper id="yjnSub" $canStickToBottom={this.state.canStickToBottom}>
        <FixableArea
          id="yjnFixableArea"
          $canStickToBottom={this.state.canStickToBottom}
          $hasPadding={!!this.props.hasOverlayAd}
        >
          <div>{wrapped}</div>
        </FixableArea>
      </Wrapper>
    );
  }

  private registerFixedValidation() {
    // 広告による再レイアウトでの追従エリアの高さ変更を検知する
    const yjnFixableAreaElement = document.getElementById('yjnFixableArea');
    const contentsWrapElement = document.getElementById('contentsWrap');

    if (!yjnFixableAreaElement || !contentsWrapElement) {
      return;
    }

    window.addEventListener('resize', this.subColumnFixed);

    this.resizeObserver = new ResizeObserver(() => {
      this.subColumnFixed();
    });

    this.resizeObserver.observe(yjnFixableAreaElement);
    this.resizeObserver.observe(contentsWrapElement);
  }

  private unregisterFixedValidation() {
    window.removeEventListener('resize', this.subColumnFixed);
    this.resizeObserver?.disconnect();
  }

  private subColumnFixed = () => {
    const yjnFixableAreaElement = document.getElementById('yjnFixableArea');
    const contentsWrapElement = document.getElementById('contentsWrap');
    if (!yjnFixableAreaElement || !contentsWrapElement) {
      return;
    }

    // FIXME: contentsWrapより下にコンテンツが掲出される場合があり、その場合は少なく主カラムの高さを見積もってしまう
    const mainColumnHeight = contentsWrapElement.getBoundingClientRect().height;
    const fixableAreaHeight = yjnFixableAreaElement.getBoundingClientRect().height;

    // 固定時に上部に隙間ができないようにするため、ウィンドウ高さよりも追従エリアが大きい場合は固定しない
    const canStickToBottom = mainColumnHeight > fixableAreaHeight && fixableAreaHeight > window.innerHeight;

    this.setState({
      canStickToBottom
    });
  };

  private changeViewportWhenPrimeVisionShown = () => {
    // プライムビジョンがiPadで表示されているときに表示が崩れることがあるので、viewportを1250にする
    const viewportElement = document.querySelector("meta[name='viewport']");
    const yjnSubElement = document.getElementById('yjnSub');
    if (viewportElement && yjnSubElement && yjnSubElement.scrollWidth > yjnSubElement.clientWidth) {
      viewportElement.setAttribute('content', 'width=1250');
    }
  };
}
